import React, { useState } from 'react';
import styled from 'styled-components'
import Carousel from 'react-bootstrap/Carousel'


const QuoteFrom = styled.p`
        text-align: right;
`

const ItemWrapper = styled.div`
    padding: 50px;
    width: 70%;
    margin: 2vw auto 0;
    @media screen and (max-width: 1000px) {
        width: 90%;
    }
`


const Slides = ({props}) => {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };


    const slides = props.map(data => {
        return (
            <Carousel.Item key={data.id}>
            <ItemWrapper>
            <p>{data.text}</p>
            <QuoteFrom>{data.fullname}</QuoteFrom>
            </ItemWrapper>
            </Carousel.Item>
        )
    })

    return (
        <Carousel activeIndex={index} onSelect={handleSelect}>
            {slides}
        </Carousel>
    );
}

export default Slides;